import { cleanParams } from '../../utils';

export const getMappedParams = values => {
  const params = {
    buyerOrderTimeFrom: values.buyerOrderDateFrom,
    buyerOrderTimeTo: values.buyerOrderDateTo,
    sellerAccountId: values.accountsQueryString,
    salePriceFrom: values.destinationPriceFrom,
    salePriceTo: values.destinationPriceTo,
    profitFrom: values.profitFrom,
    profitTo: values.profitTo,
    estimatedShippingTimeFrom: values.estimatedShippingTimeFrom,
    estimatedShippingTimeTo: values.estimatedShippingTimeTo,
    globalShippingProgram: values.ebayGlobalShippingProgram,
    lateShipment: values.lateShipment,
    status: values.statuses,
    failedReason: values.failedReason,
    sourceMarketPlaceIds: values.sourceMarketPlaceIds,
  };
  return cleanParams(params);
};
